import { Component, Directive, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { GazeMapDetail, GazeMapErgo } from 'src/app/core/models/gaze-map';
import { User } from 'src/app/core/models/user.model';
import { GazeMapService } from 'src/app/core/services/gaze-map.service';
import * as utils from 'src/app/shared/helpers/utils';
import { DdbbUtils } from 'src/app/shared/helpers/utils';
import { MimesysTranslationsService } from 'src/app/core/services/mimesys-translations.service';
import { ConfigService } from 'src/app/core/services/config.service';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { DomSanitizer } from '@angular/platform-browser';
import { SettingsService } from 'src/app/core/services/settings.service';
import { LoadingService } from 'src/app/core/services/loading.service';
import { Entity } from 'src/app/core/models/entity.model';
import { EntityService } from 'src/app/core/services/entity.service';
import { CanComponentDeactivate } from 'src/app/core/guards/unsavedChanges.guard';

@Component({
  selector: 'hbo-gaze-map-actions',
  templateUrl: './gaze-map-actions.component.html',
  styleUrls: ['./gaze-map-actions.component.scss']
})

export class GazeMapActionsComponent implements OnInit, CanComponentDeactivate {

  gazeMap!: GazeMapDetail;

  user: User = utils?.localStorageGetItem('user');

  viewRawData = false;

  hidden!: boolean;

  translateLstnr: Subscription | undefined = new Subscription;

  reversedLangDir = ['he', 'ar'];

  whileCreatingPdf: boolean = false;
  domSanitizer: any;

  pdfStylingDiv: boolean = false;

  /*---listener language settings form change
    //let set different settings for different language*/
  mainSettings: boolean = true;

  testId!: string;

  privacity: boolean = false;
  gazeMapPersitance!: number;

  stroke: string = 'red';

  videoName?: string;

  ergoData!: GazeMapErgo;
  action: { refresh: boolean } = { refresh: true };

  referenceOriginalValue: string = '';
  referenceHasUnsavedChanges: boolean = false;

  lensOfficePrefix: string = '';

  constructor(
    private ddbbUtils: DdbbUtils,
    private mimesysTranslationsService: MimesysTranslationsService,
    public configSvc: ConfigService,
    private sanitizer: DomSanitizer,
    public gazeMapService: GazeMapService,
    private route: ActivatedRoute,
    private router: Router,
    private translate: TranslateService,
    private settingsService: SettingsService,
    private loadingService: LoadingService,
    private entityService: EntityService

  ) {
    //this.ddbbUtils.getEntityChilds(this.user.entityId);
    this.translateLstnr = this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.ngOnInit();
      this.mimesysTranslationsService.loadLanguage(event.lang.split('-')[0]).subscribe();
    });
    this.mimesysTranslationsService.loadLanguage(this.translate.currentLang.split('-')[0]).subscribe();
  }

  get isExternalReportingEnabled(): boolean {
    return this.gazeMapService.currentGazeMapSettingsValue.settings?.externalReporting?.enabled ?? false;
  }

  ngOnInit() {

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutationRecord) {
        if (target?.className == 'modal fade') {
          if (utils.localStorageGetItem('video')) (
            loadingSvc.startLoading(),
            utils.localStorageRemoveItem('video')
          )
        }
        /*if (targetCorridor?.className == 'modal fade') {
          iniCorridor = false
        }*/
      });
    });

    var loadingSvc = this.loadingService;
    var target = document.getElementById('videoModal');
    observer.observe(target!, { attributes: true, attributeFilter: ['style'] });
    !this.gazeMapService.currentGazeMapSettingsValue.clientId
      ? this.gazeMapService.setCurrentGazeMapSettings(JSON.parse(localStorage.getItem('focused_mimesys_settings')!))
      : null
    const clientId = this.gazeMapService.GazeMapSettings.clientId ? this.gazeMapService.GazeMapSettings.clientId : this.gazeMapService.currentGazeMapSettingsValue.clientId
    this.referenceOriginalValue = this.referenciaRealValue;
    //if(!utils.localStorageGetItem('video')){
    this.setSettingsAncestor().then(ancestorResponse => {
      this.settingsService.getMimesys(
        ancestorResponse.id,
        ancestorResponse.base64,
        4, //entityTypeId: the entity type of a result is always 4 (shop)
        "en",
        "",
        true
      ).subscribe(
        res => {
          this.gazeMapService.setCurrentGazeMapParamSettings('settings', res);
          this.testId = this.route.snapshot.paramMap.get('testId')!;
          if (res.environments_3d) {
            switch (res.environments_3d.lo_environment_id) {
              case 2:
                this.lensOfficePrefix = 'Stepper_';
                break;
              default:
                this.lensOfficePrefix = '';
                break;
            }
          }

          if (this.testId) {
            this.getDetail();
          }
        },
        err => {
          if (err.status == 404) {
            this.settingsService.updateMimesys(ancestorResponse.id, ancestorResponse.base64, 4, { "settings": { "timezone": ancestorResponse.timezone } }).subscribe(
              res => {
                this.settingsService.getMimesys(
                  ancestorResponse.id,
                  ancestorResponse.base64,
                  4, //entityTypeId: the entity type of a result is always 4 (shop)
                  "en",
                  "",
                  true
                ).subscribe(
                  res => {
                    this.gazeMapService.setCurrentGazeMapParamSettings('settings', res);
                    this.testId = this.route.snapshot.paramMap.get('testId')!;
                    if (this.testId) {
                      this.getDetail();
                    }
                  }
                )
              },
              err => {
                console.log("Error creating settings Mimesys");
              });
          }
        }
      )

      this.settingsService.getMimesysVideo(
        clientId!,
        ancestorResponse.base64
      ).subscribe(
        res => {
          const video_enabled = res.video_metadata.enabled;
          video_enabled ? utils.localStorageSetItem('video', { video: res.url }) : utils.localStorageRemoveItem('video');
          this.showVideo();
        },
        err => {
          console.log("err", err);
        });
    })
    //}
    // this.showVideo();

    /*this.testId = this.route.snapshot.paramMap.get('testId')!;
    if (this.testId) {
      this.getDetail();
    }*/
  }

  onInputChange() {
    this.referenceHasUnsavedChanges = this.referenciaRealValue !== this.referenceOriginalValue;
  }

  showVideo(_close?: boolean) {
    let video = null;
    this.videoName = utils.localStorageGetItem('video').video;
    if (this.videoName) {
      _close && utils.localStorageGetItem('video')
        ? this.loadingService.startLoading()
        : (
          this.loadingService.stopLoading(),
          video = document.querySelector('video'),
          video!.setAttribute('src', utils.localStorageGetItem('video').video),
          video!.play()
        )
      this.clickButtonModal();
    } else {
      utils.localStorageRemoveItem('video');
    }
  }

  setSettingsAncestor(): Promise<{ data: any; base64: string, id: string, timezone: string }> {
    let entityToSettings = this.gazeMapService.GazeMapSettings.userChildEntities
      ? this.gazeMapService.GazeMapSettings.userChildEntities
      : this.gazeMapService.currentGazeMapSettingsValue.userChildEntities

    entityToSettings = entityToSettings ? entityToSettings : this.user.entity
    return new Promise(async (resolve, reject) => {
      await this.entityService.getAncestor(entityToSettings).subscribe(
        async res => {
          let parentEntity = res.parentEntity;
          let object = {
            "hierarchy": {
              "shop_id": String(entityToSettings.internalCode ? entityToSettings.internalCode : entityToSettings.id),
              "ancestor": {
                "shop_id": String(parentEntity?.internalCode ? parentEntity?.internalCode : parentEntity?.id),
                "ancestor": entityToSettings?.entityTypeId != 2
                  ? {
                    "shop_id": String(parentEntity?.parentEntity?.internalCode ? parentEntity?.parentEntity?.internalCode : parentEntity?.parentEntity?.id),
                    "ancestor": parentEntity?.parentEntity?.entityTypeId == 2
                      ? {
                        "shop_id": String(parentEntity?.parentEntity?.parentEntity?.internalCode ? parentEntity?.parentEntity?.parentEntity?.internalCode : parentEntity?.parentEntity?.parentEntity?.id),
                        "ancestor": null
                      }
                      : null
                  }
                  : null
              }
            }
          }
          resolve({
            data: object, base64: utils.objectToBase64(object),
            id: String(entityToSettings.internalCode ? entityToSettings.internalCode : entityToSettings.id),
            timezone: String(entityToSettings?.timezone)
          });
          //resolve({ data: object, base64: utils.objectToBase64(object) });
        },
        err => {
          reject(err)
        });
    });
  }

  clickButtonModal() {
    const link = document.createElement('button');
    link.setAttribute('data-bs-toggle', 'modal');
    link.setAttribute('data-bs-target', '#videoModal');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  ngOnDestroy() {
    this.gazeMapService.setCurrentGazeMapParamConfig('testId', null);
    this.translateLstnr?.unsubscribe();
    // utils.localStorageRemoveItem('gazeMapPersitance');
    utils.localStorageRemoveItem('video');
  }

  /*getSettings(_lan?: string) {

    !this.gazeMapService.currentGazeMapSettingsValue.clientId
      ? this.gazeMapService.setCurrentGazeMapSettings(JSON.parse(localStorage.getItem('focused_mimesys_settings')!))
      : null

    this.settingsService.getMimesys(this.gazeMapService.currentGazeMapSettingsValue.clientId!, _lan ? _lan : this.translate.currentLang, this.mainSettings).subscribe(res => {
      console.log(res);
      if (res.response == "not founded" || (res.errorType && res.errorType == "IndexError")) {
        this.settingsService.getMimesys(1, _lan ? _lan : this.translate.currentLang, this.mainSettings).subscribe(res => {
          this.gazeMapService.setCurrentGazeMapParamSettings('settings', res);
          this.getDetail();
        })
      } // prevent from data alignment due to environments))
      else {
        this.gazeMapService.setCurrentGazeMapParamSettings('settings', res);
        this.getDetail();
      }
    }, error => {

    });
  }*/

  getDetail() {
    this.loadingService.startLoading()
    this.gazeMapPersitance = utils.localStorageGetItem('gazeMapPersitance');
    if (!this.gazeMapPersitance) (
      this.gazeMapPersitance = Number(this.gazeMapService.currentGazeMapSettingsValue.parentEntityId!.toString().split('(')[0]),
      utils.localStorageSetItem('gazeMapPersitance', this.gazeMapPersitance)
    )
    let mapsDisplay = this.gazeMapService.currentGazeMapSettingsValue.settings!.mapsDisplay;
    let additionalMapsDisplay = this.gazeMapService.currentGazeMapSettingsValue.settings!.additionalMapsDisplay;
    this.gazeMapService.show(this.user.role?.id!, this.testId, this.translate.currentLang, this.gazeMapPersitance, mapsDisplay, additionalMapsDisplay, this.videoName).subscribe(gazeMapDetail => {
      this.gazeMap = gazeMapDetail;
      this.privacity = gazeMapDetail.privacity;
      this.ergoData = {
        longYMin: this.gazeMap.l?.yMin,
        longYMax: this.gazeMap.l?.yMax,
        shortYMin: this.gazeMap.s.yMin,
        shortYMax: this.gazeMap.s.yMax,
        VRA: 0,
        panto: 0,
        bvd: 0,
        ergoPath: 0
      }
      //dynamodb cannot contain an index label with empty string
      this.referenciaRealValue = this.gazeMap.s.referencia == 'empty' || this.gazeMap.s.referencia == 'null' ? '' : this.gazeMap.s.referencia;
      this.gazeMap.s.status == 'hidden'
        ? this.hidden = true
        : this.hidden = false;
      this.gazeMapService.setCurrentGazeMapParamConfig('testId', this.testId);
      //this.gazeMapService.setCurrentGazeMapParamSettings('settings', gazeMapDetail.license);
      if (utils.localStorageGetItem('video')) {
        utils.localStorageRemoveItem('video');
        //this.clickButtonModal();
      }
    });
  }

  save() {
    this.gazeMapService.update(this.gazeMap.s.testId, this.referenciaRealValue, this.privacity, this.gazeMapPersitance).subscribe();
    this.referenceOriginalValue = this.referenciaRealValue;
    this.referenceHasUnsavedChanges = false;
  }

  canDeactivate(): boolean {
    return !this.referenceHasUnsavedChanges;
  }

  delete() {
    this.gazeMapService.destroy(this.gazeMap.s.testId, { mode: this.hidden ? 'reset' : 'hide' }).subscribe(() => {
      this.router.navigate(['gaze-maps'])
    });
  }

  downloadCsv() {
    console.log('Download CSV');
  }

  setDownoladablePdf() {
    this.loadingService.startLoading();
    this.viewRawData = false;
    this.whileCreatingPdf = true;
    setTimeout(() => {
      this.downloadPdf();
    }, 0);
  }

  downloadPdf() {
    this.whileCreatingPdf = true;
    switch (this.gazeMapService.currentGazeMapSettingsValue.settings!.template) {
      case 'Bi-fold-brochure':
        if (this.testId![0] == '1') { data = document.getElementById('gaze-map-containter-to-pdf-bi-fold-brochure') };
        if (this.testId![0] == '3') { data = document.getElementById('gaze-map-containter-to-pdf-bi-fold-brochure-office') };
        if (this.testId![0] == '4') { data = document.getElementById('gaze-map-containter-to-pdf-bi-fold-brochure-svision') };
        break;
      default:
        var data = document.getElementById('gaze-map-containter-to-pdf');
        data!.id = 'gaze-map-containter-to-pdf-copied'
        if (this.testId![0] == '1') { data!.id = 'gaze-map-containter-to-pdf-copied' }
        if (this.testId![0] == '3') { data!.id = 'gaze-map-containter-to-pdf-copied-office' }
        if (this.testId![0] == '4') { data!.id = 'gaze-map-containter-to-pdf-copied-svision' }
        var dataCopy = data?.cloneNode(true);
        document.body.appendChild(dataCopy!);
        // Remove pdfStylingDiv class to avoid conflicts in the copied element, only for non bi-fold-brochure
        (dataCopy as Element).classList.remove('pdfStylingDiv');
        data!.id = 'gaze-map-containter-to-pdf';
        if (this.testId![0] == '1') { data = document.getElementById('gaze-map-containter-to-pdf-copied') }
        if (this.testId![0] == '3') { data = document.getElementById('gaze-map-containter-to-pdf-copied-office') }
        if (this.testId![0] == '4') { data = document.getElementById('gaze-map-containter-to-pdf-copied-svision') }

        break;
    }

    html2canvas(data!).then(async canvas => {
      //2480 pixels x 3508 pixels (print resolution) 595 pixels x 842 pixels (screen resolution)
      let pdf = new jsPDF('l', 'px', 'a4'); // A4 size page of PDF
      const contentDataURL = canvas.toDataURL('image/png');
      //defining logos
      let logo2Data: any;
      let logo3Data: any;
      let coverImage: any;
      let insidePageImage: any;
      let logosHeight: number = 25;
      let posX: number = 0;
      switch (this.gazeMapService.currentGazeMapSettingsValue.settings!.template) {
        case 'Bi-fold-brochure':
          const pageHeight = pdf.internal.pageSize.height; // pdf page height
          const pageWidth = pdf.internal.pageSize.width; // pdf page width
          let coverImageW = 0;
          let coverImageH = 0;
          let coverImageX = 0;
          let coverImageY = 0;
          this.gazeMapService.currentGazeMapSettingsValue.settings!.appFrontendDesign?.coverImage?.logoImage
            ? (
              coverImage = await this.getImageDimensions(this.gazeMapService.currentGazeMapSettingsValue.settings!.appFrontendDesign?.coverImage?.logoImage),
              coverImageW = pageWidth,
              coverImageH = coverImage.h * pageWidth / coverImage.w,
              coverImageY = (pageHeight - coverImageH) / 2,
              pdf.addImage(this.gazeMapService.currentGazeMapSettingsValue.settings!.appFrontendDesign?.coverImage?.logoImage, 'JPEG', coverImageX, coverImageY, coverImageW, coverImageH)
            )
            : null;
          pdf.addPage();
          let insidePageImageW = 0;
          let insidePageImageH = 0;
          let insidePageImageX = 0;
          let insidePageImageY = 0;

          //if finally only foot
          /*this.gazeMapService.currentGazeMapSettingsValue.settings!.insidePageImage
            ? (
              insidePageImage = await this.getImageDimensions(this.gazeMapService.currentGazeMapSettingsValue.settings!.insidePageImage),
              insidePageImageH = 25,
              insidePageImageW = pageWidth,
              insidePageImageX = (pageWidth - insidePageImageW) / 2,
              insidePageImageY = pageHeight - 25,
              pdf.addImage(this.gazeMapService.currentGazeMapSettingsValue.settings!.insidePageImage, 'PNG', insidePageImageX, insidePageImageY, insidePageImageW, insidePageImageH)
            )
            : null;*/
          this.gazeMapService.currentGazeMapSettingsValue.settings!.appFrontendDesign?.insidePageImage?.logoImage
            ? (
              insidePageImage = await this.getImageDimensions(this.gazeMapService.currentGazeMapSettingsValue.settings!.appFrontendDesign?.insidePageImage?.logoImage),
              insidePageImageW = pageWidth,
              insidePageImageH = insidePageImage.h * pageWidth / insidePageImage.w,
              insidePageImageY = (pageHeight - insidePageImageH) / 2,
              pdf.addImage(this.gazeMapService.currentGazeMapSettingsValue.settings!.appFrontendDesign?.insidePageImage?.logoImage, 'JPEG', insidePageImageX, insidePageImageY, insidePageImageW, insidePageImageH)
            )
            : null;


          // Few necessary setting options
          var imgWidth = 630;
          //var pageHeight = 842;
          var imgHeight = canvas.height * imgWidth / canvas.width;
          //var heightLeft = imgHeight;
          var position = 0;

          //pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight);





          if (this.gazeMapService.currentGazeMapSettingsValue.settings!.mapsDisplay == 'Fusion') {

            imgHeight = pdf.internal.pageSize.height - position - 45;
            imgWidth = canvas.width * imgHeight / canvas.height;
            posX = (pdf.internal.pageSize.width - imgWidth) / 2

            if (imgWidth > pdf.internal.pageSize.width) {
              imgWidth = pdf.internal.pageSize.width;
              imgHeight = canvas.height * imgWidth / canvas.width;
              posX = (pdf.internal.pageSize.width - imgWidth) / 2
            }

          }
          pdf.addImage(contentDataURL, 'PNG', posX, position, imgWidth, imgHeight);


          break;
        default:
          // Few necessary setting options
          var imgWidth = 630;
          //var pageHeight = 842;
          var imgHeight = canvas.height * imgWidth / canvas.width;
          //var heightLeft = imgHeight;

          var position = 10;



          this.gazeMapService.currentGazeMapSettingsValue.settings!.appFrontendDesign?.logo2?.logoImage
            ? (
              logo2Data = await this.getImageDimensions(this.gazeMapService.currentGazeMapSettingsValue.settings!.appFrontendDesign?.logo2?.logoImage),
              pdf.addImage(this.gazeMapService.currentGazeMapSettingsValue.settings!.appFrontendDesign?.logo2?.logoImage, 'PNG', 10, position, logo2Data.w * logosHeight / logo2Data.h, logosHeight)
            )
            : null;
          this.gazeMapService.currentGazeMapSettingsValue.settings!.appFrontendDesign?.logo3?.logoImage
            ? (
              logo3Data = await this.getImageDimensions(this.gazeMapService.currentGazeMapSettingsValue.settings!.appFrontendDesign?.logo3?.logoImage),
              pdf.addImage(this.gazeMapService.currentGazeMapSettingsValue.settings!.appFrontendDesign?.logo3?.logoImage, 'PNG', imgWidth - logo3Data.w * logosHeight / logo3Data.h - 10, position, logo3Data.w * logosHeight / logo3Data.h, logosHeight)
            )

            : null;

          position += logosHeight + 5;

          posX = 0;
          if (this.gazeMapService.currentGazeMapSettingsValue.settings!.mapsDisplay == 'Fusion') {

            imgHeight = pdf.internal.pageSize.height - position;
            imgWidth = canvas.width * imgHeight / canvas.height;
            posX = (pdf.internal.pageSize.width - imgWidth) / 2;

            if (imgWidth > pdf.internal.pageSize.width) {
              imgWidth = pdf.internal.pageSize.width;
              imgHeight = canvas.height * imgWidth / canvas.width;
              posX = (pdf.internal.pageSize.width - imgWidth) / 2
            }
          }
          pdf.addImage(contentDataURL, 'PNG', posX, position, imgWidth, imgHeight);
          break;
      }

      pdf.save(`${this.route.snapshot.paramMap.get('testId')}.pdf`); // Generated PDFs
      this.whileCreatingPdf = false;
      this.loadingService.stopLoading();
      switch (this.gazeMapService.currentGazeMapSettingsValue.settings!.template) {
        case 'Bi-fold-brochure':
          break;
        default:
          document.body.removeChild(dataCopy!);
          this.viewRawData
      }
    });
  }

  getImageDimensions(file: string) {
    return new Promise(function (resolved, rejected) {
      var i = new Image()
      i.onload = function () {
        resolved({ w: i.width, h: i.height })
      };
      i.src = file
    })
  }

  reverse_lan_dir() {
    if (this.reversedLangDir.includes(this.translate.currentLang)) {
      return true
    } else {
      return false
    }
  }

  //dynamodb cannot contain an index label with empty string
  referenciaRealValue!: string;
  get displayValue() { return this.referenciaRealValue; }
  set displayValue(v) { v == 'empty' ? this.referenciaRealValue = '' : this.referenciaRealValue = v; }

  transform(url: string) {
    /*this.getBase64ImageFromUrl(url)
      .then(result => console.log(result))
      .catch(err => console.error(err));*/
    return '/assets/images/desktop/' + url
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  async getBase64ImageFromUrl(imageUrl: string) {
    var res = await fetch(imageUrl);
    var blob = await res.blob();

    return new Promise((resolve, reject) => {
      var reader = new FileReader();
      reader.addEventListener("load", function () {
        resolve(reader.result);
      }, false);

      reader.onerror = () => {
        return reject(this);
      };
      reader.readAsDataURL(blob);
    })
  }

  initializeCorridor() {
    this.action = { refresh: true };
    console.log(this.action);
  }

}
